import axios from "axios";
import buildUrl from "build-url-ts";
import { Account } from "src/types/accounts";

const BASE_URL = process.env.REACT_APP_API_URL;
const accountUrl = `${BASE_URL}/api/2.0`;

export const viewerSettingsApi = {

  fetchAccount: async (): Promise<Account> => {
    const url = buildUrl(`${accountUrl}/accounts`);
    const response = await axios.get(url);
    return response.data;
  },

  updateAccount: async (data): Promise<Account> => {
    const url = buildUrl(`${accountUrl}/accounts`);
    const response = await axios.put(url, data);
    return response.data;
  },

};
